/**
 *  MeanMachineView
 *
 *  Created by Legman on 27/03/2017.
 *
 */

import Common from "../Common";
import RaceCarView from "../race/RaceCarView"

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
export default class MeanMachineView extends RaceCarView {
    constructor() {
        super();

        this._shadow.y = 152;

        this._front.offset.y = -50;
        this._back.offset.y = -50;

        this._wheels.front.left.offset = new PIXI.Point(-200, 66);
        this._wheels.front.right.offset = new PIXI.Point(200, 66);

        this._wheels.rear.left.offset = new PIXI.Point(-190, 92);
        this._wheels.rear.right.offset = new PIXI.Point(190, 92);
    }

    init() {
    }

    destroy(destroyChildren) {
    }

    /**
     * @param {number} dt
     * @param {number} distance
     * @param {number} curvature
     * @param {number} gradient
     * @param {number} velocity
     * @param {number} turnVelocity
     * @param {number} jumpOffset
     */
    update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
        super.update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

        const scalar = 140;

        this._curvature += ((turnVelocity + curvature) - this._curvature) * 0.4;
        this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

        this._front.x = this._curvature * 0.3 + this._front.offset.x;
        this._front.y = (-gradient * scalar * 1.6) + this._front.offset.y - (jumpOffset * 128);

        this._back.x = -this._curvature * 0.1 + this._back.offset.x;
        this._back.y = (gradient * scalar) + this._back.offset.y - (jumpOffset * 118);

        this._front.rotation = this._curvature * 0.0012;
        this._back.rotation = this._curvature * 0.0012;

        this._wheels.front.left.x = this._front.x + this._wheels.front.left.offset.x;
        this._wheels.front.left.y = (gradient * scalar) + this._wheels.front.left.offset.y - (jumpOffset * 104);

        this._wheels.front.right.x = this._front.x + this._wheels.front.right.offset.x;
        this._wheels.front.right.y = (gradient * scalar) + this._wheels.front.right.offset.y - (jumpOffset * 104);

        this._wheels.rear.left.x = this._back.x + this._wheels.rear.left.offset.x;
        this._wheels.rear.left.y = (gradient * scalar) + this._wheels.rear.left.offset.y - (jumpOffset * 92);

        this._wheels.rear.right.x = this._back.x + this._wheels.rear.right.offset.x;
        this._wheels.rear.right.y = (gradient * scalar) + this._wheels.rear.right.offset.y - (jumpOffset * 92);

        velocity = Math.max(0, velocity) / 0.2;
        this._wheels.front.left.animationSpeed = velocity;
        this._wheels.front.right.animationSpeed = velocity;
        this._wheels.rear.left.animationSpeed = velocity;
        this._wheels.rear.right.animationSpeed = velocity;
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createFrontLayer() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("dastardly_front_00"));
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createBackLayer() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("dastardly_rear_00"));
    }

    /**
     * @returns {p3.MovieClip}
     */
    createFrontWheel() {
        const assets = Common.assets;
        const sequence = new p3.MovieClipSequence();
        sequence.addTextures([
            assets.getTexture("dastardly_front_wheel_00")
        ]);
        return new p3.MovieClip(sequence);
    }

    /**
     * @returns {p3.MovieClip}
     */
    createRearWheel() {
        const assets = Common.assets;
        const sequence = new p3.MovieClipSequence();
        sequence.addTextures([
            assets.getTexture("dastardly_rear_wheel_00")
        ]);
        return new p3.MovieClip(sequence);
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createShadow() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("dastardly_shadow_00"));
    }
}